module.exports = __webpack_public_path__ + "img/solena-flag-outline.d098987a.png";